export default __webpack_public_path__ + "static/media/fotoPrincipal_Dashport_bajaResolucion.59f37e98.webp";